import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Header from '../../components/Header'
import Footer from '../../components/Footer'
import {
    Mila, Elena, Kamen, Antoaneta, Atanaska, Elisaveta,
    Ilia, Mariana, Milena, Roberto, Svetlana, Viara, Zdravko
} from '../../modules/OurTeam'
import './styles.css'

export const Row = (props) => {
    return (
        <div className={`row ${props.className ? props.className : ''}`}>
            {props.children}
        </div>
    )
}
export const Col = (props) => {
    return (
        <div className={`col ${props.className ? props.className : ''}`}>
            {props.children}
        </div>
    )
}

const MainLayout = ({children, loading}) => {
    const isLoading = Object.values(loading).filter(val => val===true).length > 0;
    return (
        <div className={`${isLoading ? 'loading': ''} wrapper layout-main`}>
            <Header />
            <div className="content container">
                {children}
            </div>
            <Footer/>
        </div>
    )
}

MainLayout.propTypes = {

}

const mapStateToProps = state => ({
    loading: state.Global.loading
})

export default connect(mapStateToProps)(MainLayout)



// WEBPACK FOOTER //
// ./src/layouts/Main/index.jsx